import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AlertController,LoadingController,NavController } from '@ionic/angular';
import { HelperService } from 'src/app/services/helper.service';
import { ActionSheetController } from '@ionic/angular';
import {StoreService} from 'src/app/services/store.service'
import { UserService } from 'src/app/services/user.service';


@Component({
  selector: 'app-search-product',
  templateUrl: './search-product.page.html',
  styleUrls: ['./search-product.page.scss'],
})
export class SearchProductPage implements OnInit {

  category: any;
    subCategory: any;
    isPromoActiveFlag: any;
    storeDetail: any;
    city: any;
    pin: any;
    searchParams: any;
    isLoadData: boolean;
    searchResultData: any=[];
    resultsAvailable: boolean=false;
    backPageFlag: any={};
    resultsNotAvailable=0;
    noDataImage : any;
    offset : any=0;
    a:boolean=false;
  searchValue: any;
  userId: string;
  addedToWishlist: any;
  cart: any[];
  show: number;
  qty: any;

  constructor(public loadingController: LoadingController, private userService:UserService, private routerActivate: ActivatedRoute,  private router: Router, private authService: StoreService,   public actionSheetController: ActionSheetController, public alertController: AlertController, private navController:NavController,private toast: HelperService
    ){}
/***Added by Parul for searching the products and get suggestion based on typing */

  ngOnInit() {
    this.searchResultData=[];
    
    // console.log("enter in ngOnInit function")
    this.routerActivate.queryParams.subscribe(params => {
      this.searchValue = params.search;
      console.log(this.searchValue,'search..');
      if (this.router.getCurrentNavigation().extras.state) {
        this.category = this.router.getCurrentNavigation().extras.state.cat;
        this.subCategory = this.router.getCurrentNavigation().extras.state.subCat;
        this.isPromoActiveFlag = this.router.getCurrentNavigation().extras.state.isPromoActiveFlag;
        this.storeDetail = this.router.getCurrentNavigation().extras.state.backPageFlag.storeDetail;
        this.city = this.router.getCurrentNavigation().extras.state.city;
        this.pin = this.router.getCurrentNavigation().extras.state.pin;
        this.backPageFlag = this.router.getCurrentNavigation().extras.state.backPageFlag;
        this.searchParams = this.router.getCurrentNavigation().extras.state.search;
      }
    });
 
    // console.log("@@@",this.searchValue,this.city)
    this.searchParams=this.searchValue
    console.log(localStorage.getItem("city"))
    this.userId = localStorage.getItem('userId')
  
  }
  // edit by vikash kumar
  // search direct
  ionViewWillEnter(){
    this.getProducts(this.searchValue,this.city);
  }
  getProducts(search:any,city,){
    var cart = JSON.parse(localStorage.getItem("cart"))
    this.searchResultData=[]
    this.offset+=0;
    const formData = {
      "search": search,
      "city": localStorage.getItem("city"),
      limit : 1000,
      offset : this.offset
    }
    console.log(this.city)
    this.authService.getProduct(formData).subscribe((result: any) => {
      console.log(result.length);

      for (let i = 0; i < result.length; i++) {
        this.searchResultData.push(result[i]);

        var product = cart.filter((element: any)=>element.id==this.searchResultData[i]._id)[0]
        if(product)
        this.searchResultData[i]['qty'] = product.qty
      

    }
      if(this.searchResultData.length>0){
          this.resultsAvailable=true;
          this.resultsNotAvailable=0;
          console.log("hello")
      
      }
      else{
        this.resultsNotAvailable=1;
        console.log("hiiii")
        
      }
  })
  this.presentLoading()
  }
  // fetchCatStoreTerm(searchParams,loaded,event?) {
  //   if(!loaded){
  //     this.searchResultData=[];
  //   }
    
  //   console.log(this.searchParams,"hello")
  //   if (this.searchParams.length > 2) {
  //     if(loaded){
  //       this.offset+=0;
  //     }
  //     const formData = {
  //       "search": this.searchParams,
  //       "city": localStorage.getItem("city"),
  //       limit : 20,
  //       offset : this.offset
  //     }
  //     this.authService.getProduct(formData).subscribe((result: any) => {
  //       console.log(result.length);
  //       this.searchResultData=[...this.searchResultData,...result];
  //       if(this.searchResultData.length>0){
  //           this.resultsAvailable=true;
  //           this.resultsNotAvailable=0;
  //           console.log("hello")
  //       }
  //       else{
  //         this.resultsNotAvailable=1;
  //         console.log("hiiii")
          
  //       }

  //        if(event){
  //       event.target.complete();
  //     }
  //   })}else{
  //     this.searchResultData=[];
  //   }
  // }
  supplierSelected(productItem:any){
    console.log(productItem);
      this.router.navigate(['/product-detail/'+productItem._id]);
      // console.log("product item object clickable product", navigationParams);
  }

  doInfinite($event){
    if (this.searchParams.length > 2) {
      const formData = {
        "search": this.searchParams,
        "cat": this.category,
        "subcat": this.subCategory,
        "city": this.city,
        limit : 30,
        offset : 30
      }
      this.authService.getProduct(formData).subscribe((result: any) => {
        console.log(result);
        this.searchResultData=result;
        if(this.searchResultData.length>0){
            this.resultsAvailable=true;
        }
        
      })}
  }
  goBack(){
    this.navController.pop();
  }

  notifications(){
    this.router.navigate(['/wishlist'])
  }
  home(){
    this.router.navigate(['/'])
  }

  handleMissingImage($event){
    console.log($event)
    console.log("hello error");
    ($event.target as HTMLImageElement).style.display = 'none'
    this.a=true;
  }
  handleAddToCarta(productObj) {
    console.log("productObj ", productObj)

    this.cart = []
    if (productObj.qty) {///Added by Parul
      ++productObj.qty
    }
    else {
      productObj['qty'] = 1;
    }
    let cart = localStorage.getItem("cart");
    if (cart) {
      this.cart = JSON.parse(cart);
      console.log("cart ", this.cart)
      let filtered = this.cart.filter(product => product.id == productObj._id)
      console.log("filtered ", filtered)
      if (filtered.length == 0) {
        var pdata = {
          id: productObj._id,
          qty:1
        }
        console.log(pdata)
        this.cart.push(pdata)
        localStorage.setItem('cart', JSON.stringify(this.cart))
        // this.show = 1
      } else {
        console.log(this.show)
        let index = this.cart.indexOf(filtered[0]);
        console.log("index ", index)
        this.cart[index]['qty'] = productObj.qty;//Added by Parul
        // this.cart.splice(index, 1)
        localStorage.setItem('cart', JSON.stringify(this.cart))
        // this.show = null

      }
    } else {
      console.log("item._id ", productObj._id)
      var pdata = {
        id: productObj._id,
        qty: 1
      }
      this.cart.push(pdata)
      localStorage.setItem('cart', JSON.stringify(this.cart))
      this.show = 1
    }
    this.userService.cartUpdated.next(true);
  }

  deleteFromCart(item) {
    if (item.qty > 0) {
      --item.qty;
      this.cart = []
      let cart = localStorage.getItem("cart");
      if (cart) {
        this.cart = JSON.parse(cart);
        console.log("cart ", this.cart)
        let filtered = this.cart.filter(product => product.id == item._id)
        let index = this.cart.indexOf(filtered[0])
        this.cart[index]['qty'] = item.qty;
        if (item.qty == 0) {
          this.cart.splice(index, 1)
        }
        localStorage.setItem('cart', JSON.stringify(this.cart))
        this.userService.cartUpdated.next(true);
      }
      // this.loadCartItems();

    }
  }
  async presentLoading() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      duration: 3000,
    });
    await loading.present();

    const { role, data } = await loading.onDidDismiss();
    console.log('Loading dismissed!');
  }
  }

